// extracted by mini-css-extract-plugin
module.exports = {"snackbar":"Snackbar_snackbar__1-2gT","show":"Snackbar_show__1p7nf","success":"Snackbar_success__yN79T","error":"Snackbar_error__2a-E5"};